'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChangeEvent } from 'react';
import { styled } from '@classify/react-core-components/styles';
import { useFormikContext } from 'formik';
import { FormGroup, Checkbox } from '@mui/material';
import { translate } from '@openclassrooms/translations';
import { useUpdateQuizSessionQuestionsAnswers } from '@openclassrooms/data-connect-web/assessment';
import type { Answer } from '@openclassrooms/sdk-web';
import Typography from '@classify/react-core-components/Typography';
import AnswerWrapper from './AnswerWrapper';
import { MultipleAnswerWrong, MultipleAnswerRight } from './AnswerIcons';
const Warning = styled(Typography)(({
  theme: {
    spacing
  }
}) => ({
  marginBottom: spacing(2)
}));
const StatusIcon = styled('svg')({
  flexShrink: 0,
  width: 18,
  height: 18
});
const IconWrapper = styled('span')(({
  theme: {
    spacing
  }
}) => ({
  display: 'flex',
  justifyItems: 'center',
  alignItems: 'center',
  padding: spacing(1),
  width: 24,
  height: 24
}));
interface Props {
  answers: Answer[];
  questionId: number;
  isCompleted?: boolean;
  quizSessionQuestionId: number;
}
export default function MultipleAnswerQuestion(t0) {
  const $ = _c(25);
  const {
    answers,
    questionId,
    isCompleted: t1,
    quizSessionQuestionId
  } = t0;
  const isCompleted = t1 === undefined ? false : t1;
  const {
    values,
    setFieldValue
  } = useFormikContext();
  let t2;
  if ($[0] !== quizSessionQuestionId) {
    t2 = {
      quizSessionQuestionId
    };
    $[0] = quizSessionQuestionId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [updateAnswer] = useUpdateQuizSessionQuestionsAnswers(t2);
  const selectedAnswers = values[questionId];
  let t3;
  if ($[2] !== isCompleted || $[3] !== questionId || $[4] !== selectedAnswers || $[5] !== setFieldValue || $[6] !== updateAnswer) {
    t3 = e => {
      if (isCompleted) {
        return;
      }
      const checkedAnswers = new Set(selectedAnswers);
      const value = Number(e.target.value);
      if (e.target.checked) {
        checkedAnswers.add(value);
      } else {
        checkedAnswers.delete(value);
      }
      setFieldValue(`${questionId}`, Array.from(checkedAnswers));
      updateAnswer([...checkedAnswers]);
    };
    $[2] = isCompleted;
    $[3] = questionId;
    $[4] = selectedAnswers;
    $[5] = setFieldValue;
    $[6] = updateAnswer;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleChange = t3;
  let t4;
  if ($[8] !== handleChange || $[9] !== questionId) {
    t4 = (isCorrect, isChecked, id) => {
      if (isCorrect === null || isCorrect === undefined || !isChecked) {
        return <Checkbox name={String(questionId)} checked={isChecked} value={String(id)} onChange={handleChange} inputProps={{
          "data-testid": "answer"
        }} />;
      }
      if (isCorrect && isChecked) {
        return <IconWrapper aria-checked="true"><StatusIcon as={MultipleAnswerRight} data-testid="check-icon" /></IconWrapper>;
      }
      return <IconWrapper aria-checked="true"><StatusIcon as={MultipleAnswerWrong} data-testid="cross-icon" /></IconWrapper>;
    };
    $[8] = handleChange;
    $[9] = questionId;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const getControlElement = t4;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Warning variant="caption">{translate("mcq.view.message.multi_answer_warning")}</Warning>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== answers || $[13] !== getControlElement || $[14] !== isCompleted || $[15] !== questionId || $[16] !== selectedAnswers) {
    let t7;
    if ($[18] !== getControlElement || $[19] !== isCompleted || $[20] !== questionId || $[21] !== selectedAnswers) {
      t7 = t8 => {
        const {
          id: id_0,
          content,
          isCorrect: isCorrect_0,
          selected
        } = t8;
        const isChecked_0 = selectedAnswers?.includes(id_0) ?? false;
        return <AnswerWrapper key={`${questionId}-${id_0}`} content={content} isCorrect={Boolean(isCorrect_0)} control={getControlElement(isCorrect_0, isChecked_0, id_0)} isCompleted={isCompleted} warningLabel={isCorrect_0 && !selected ? translate("quiz.correction.question.item.multiple_choice.answer_missing") : null} />;
      };
      $[18] = getControlElement;
      $[19] = isCompleted;
      $[20] = questionId;
      $[21] = selectedAnswers;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    t6 = answers.map(t7);
    $[12] = answers;
    $[13] = getControlElement;
    $[14] = isCompleted;
    $[15] = questionId;
    $[16] = selectedAnswers;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[23] !== t6) {
    t7 = <div>{t5}<FormGroup>{t6}</FormGroup></div>;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}